import { get } from './client';
import { buildPath, toJson } from './utils';
import { ADMIN_MARKETS_PATH } from './constants';
import { GeneralListType } from './types';
import { Market } from './general/models';

const NEIGHBORHOODS = 'neighborhoods';

export const getAdminMarkets = (options: any): Promise<GeneralListType<Market>> =>
  get(buildPath(ADMIN_MARKETS_PATH), options).then(toJson);

export const getAdminMarketNeighborhoods = (slug: string, options: any): Promise<GeneralListType<Market>> =>
  get(buildPath(ADMIN_MARKETS_PATH, slug, NEIGHBORHOODS), options).then(toJson);
